// app/javascript/controllers/logo_selection_controller.js
import {Controller} from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["card"]

  connect() {
    this.cardTargets.forEach(card => {
      const destroy = card.querySelector('.destroy-field');
      this.updateSelection(card, destroy.value);
    });
  }

  toggleSelection(event) {
    const card = event.currentTarget;
    const destroy = card.querySelector('.destroy-field');

    // Toggle the hidden field
    destroy.value = destroy.value === '1' ? '0' : '1';

    this.updateSelection(card, destroy.value);
  }

  updateSelection(card, value) {
    card.style.backgroundColor = (value === '0' ? '#d1ecf1' : '');
  }
}
